import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StaffComponent } from "./components/staff.component";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { AccordionModule } from "primeng/accordion";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

//import { StudentModule } from '../student/student.module';

import { ViewStaffComponent, StaffService, ScanHistoryComponent } from "./index";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";

import { AddStaffComponent } from "./add-staff/add-staff.component";
import { EditStaffComponent } from "./edit-staff/edit-staff.component";

import { ScanHistoryViewDetailsComponent } from "./scanhistory/scan-history-view-details/scan-history-view-details.component";
import { DataService_ScanHistory } from "./scanhistory/shared/data.service";
import { StaffCurrentRemindersTableComponent } from "./viewstaff/staff-current-reminders-table/staff-current-reminders-table.component";
import { StaffScanHistoryRemindersComponent } from "./scanhistory/staff-scan-history-reminders/staff-scan-history-reminders.component";
import { StaffDigitalIdRegistrationComponent } from "./staff-digital-id-registration/staff-digital-id-registration.component";
import { StaffDigitalIdBatchModeComponent } from "./staff-digital-id-registration/staff-digital-id-batch-mode/staff-digital-id-batch-mode.component";
import { StaffDigitalIdEmailLogComponent } from "./staff-digital-id-registration/staff-digital-id-email-log/staff-digital-id-email-log.component";
import { StaffDigitalIdManualModeComponent } from "./staff-digital-id-registration/staff-digital-id-manual-mode/staff-digital-id-manual-mode.component";
import { StaffDigitalIdBatchImportComponent } from "./staff-digital-id-registration/staff-digital-id-batch-mode/staff-digital-id-batch-import/staff-digital-id-batch-import.component";
import { StaffDigitalIdBatchImportTableComponent } from "./staff-digital-id-registration/staff-digital-id-batch-mode/staff-digital-id-batch-import-table/staff-digital-id-batch-import-table.component";
import { StaffDigitalIdDownloadComponent } from "./staff-digital-id-registration/staff-digital-id-batch-mode/staff-digital-id-download/staff-digital-id-download.component";
import { StaffExportDigitalIdComponent } from "./staff-digital-id-registration/staff-digital-id-batch-mode/staff-export-digital-id/staff-export-digital-id.component";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { DataService_Staff_DigitalID } from "./staff-digital-id-registration/shared/data.service";
import { StaffManualEmailTableComponent } from "./staff-digital-id-registration/staff-digital-id-manual-mode/staff-manual-email-table/staff-manual-email-table.component";
import { StaffManualStaffTableComponent } from "./staff-digital-id-registration/staff-digital-id-manual-mode/staff-manual-staff-table/staff-manual-staff-table.component";
import { DigitalIdActivationInfoComponent } from "./staff-digital-id-registration/digital-id-activation-info/digital-id-activation-info.component";
import { ItemCollectionComponent } from "./itemcollection/itemcollection.component";
import { StaffNotificationsComponent } from "./staff-notifications/staff-notifications.component";
import { DataService_Staff_Notifications } from "./staff-notifications/shared/data.service";
import { DataService_itemcollection } from "./itemcollection/shared/data.service";
import { ItemCollectionAddEditComponent } from "./itemcollection/itemcollectionaddedit/itemcollectionaddedit.component";

@NgModule({
	declarations: [
		StaffComponent,
		ViewStaffComponent,
		ScanHistoryComponent,
		AddStaffComponent,
		EditStaffComponent,
		ScanHistoryViewDetailsComponent,
		StaffCurrentRemindersTableComponent,
		StaffScanHistoryRemindersComponent,
		StaffDigitalIdRegistrationComponent,
		StaffDigitalIdBatchModeComponent,
		StaffDigitalIdEmailLogComponent,
		StaffDigitalIdManualModeComponent,
		StaffDigitalIdBatchImportComponent,
		StaffDigitalIdBatchImportTableComponent,
		StaffDigitalIdDownloadComponent,
		StaffExportDigitalIdComponent,
		StaffManualEmailTableComponent,
		StaffManualStaffTableComponent,
		DigitalIdActivationInfoComponent,
		StaffNotificationsComponent,
		ItemCollectionComponent,
		ItemCollectionAddEditComponent
	],

	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		PersonSelectorModule,
		TableModule,
		DropdownModule,
		AccordionModule,
		SchoolselectorModule,
	],
	providers: [StaffService, DataService_ScanHistory, DataService_Staff_DigitalID, DataService_Staff_Notifications, DataService_itemcollection],
})
export class StaffModule {}
